import { differenceInMinutes, parseISO } from "date-fns";

interface IsShiftWithinLiveActivityTriggerTimeWindowParams {
  shiftStart: string;
  liveActivityTriggerLeadTimeMinimumInMinutes: number;
  liveActivityTriggerLeadTimeMaximumInMinutes: number;
}

export function isShiftWithinLiveActivityTriggerTimeWindow(
  params: IsShiftWithinLiveActivityTriggerTimeWindowParams
) {
  const {
    shiftStart,
    liveActivityTriggerLeadTimeMinimumInMinutes,
    liveActivityTriggerLeadTimeMaximumInMinutes,
  } = params;

  const shiftStartISO = parseISO(shiftStart);
  const now = new Date();

  const minutesUntilStart = differenceInMinutes(shiftStartISO, now);

  return (
    minutesUntilStart >= liveActivityTriggerLeadTimeMinimumInMinutes &&
    minutesUntilStart <= liveActivityTriggerLeadTimeMaximumInMinutes
  );
}
